import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Fatturazione automatica',
  buttons: {
    add_subscription: 'Aggiungi abbonamento',
    suspend_company: 'Sospendi ristorante',
    restore_company: 'Ripristina ristorante',
    edit_suspend: 'Modifica info sospensione',
    confirm: 'Conferma',
    cancel: 'Annulla',
  },
  modals: {
    suspend_company: {
      title: 'Sei sicuro di voler sospendere {{company}}?',
      description:
        'Questa azione annullerà tutti gli abbonamenti attivi, disabiliterà gli ordini live e invierà una notifica email al proprietario del ristorante riguardo alla cancellazione. Seleziona un motivo prima di confermare.',
      suspense_reason: {
        label: 'Seleziona il motivo della sospensione',
        placeholder: 'Scegli un motivo',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Chiuso o cambio proprietà',
          [SUSPENSE_REASON.LowRoi]: 'ROI basso',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Sensibilità a prezzi/commissioni',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Integrazioni mancanti/lacune di prodotto',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Onboarding/attivazione insufficiente',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Insoddisfazione del supporto',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Passato a concorrente/marketplace/fai-da-te',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Delusione nelle performance di marketing',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Registrazione/dati errati',
        },
        validation: {
          required: 'Scegli un motivo',
        },
      },
      suspense_competitor: {
        label: 'A quale concorrente sono passati?',
        placeholder: 'Scegli un concorrente',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Altro',
        },
        validation: {
          required: 'Scegli un concorrente',
        },
      },
      suspense_reason_notes: {
        label: 'Contesto aggiuntivo (opzionale)',
        placeholder: 'Fornisci dettagli aggiuntivi',
      },
    },
    restore_company: {
      title: 'Sei sicuro di voler ripristinare {{company}}?',
      description: "Dovrai comunque creare l'abbonamento e abilitare gli ordini live manualmente.",
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dettagli abbonamento fallito',
    failed_to_suspend_company: 'Sospensione ristorante fallita. Contatta il supporto tecnico',
    failed_to_restore_company: 'Ripristino ristorante fallito. Contatta il supporto tecnico',
  },
};
